import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';

const AddAllStaffModal = ({ handleAddAllStaffConfirmation }) => {
  const [showAddAllStaffModal, setShowAddAllStaffModal] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <Fragment>
      <Button
        className='float-right'
        variant='outline-success'
        onClick={() => {
          setShowAddAllStaffModal(true);
        }}
      >
        Add All Staff
      </Button>
      <Modal
        backdrop='static'
        show={showAddAllStaffModal}
        onHide={() => {
          setShowAddAllStaffModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Are you sure you would like to give access to all staff for this
            Property or Group?
          </p>
          <Button
            variant='success'
            onClick={() => {
              setLoading(true);
              handleAddAllStaffConfirmation()
                .then(() => {
                  setLoading(false);
                  setShowAddAllStaffModal(false);
                })
                .catch((err) => {
                  if (process.env.NODE_ENV === 'development')
                    console.error(err);
                });
            }}
          >
            {loading ? (
              <Spinner
                className='mx-3'
                animation='border'
                variant='success'
                size='sm'
              />
            ) : (
              'Confirm'
            )}
          </Button>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

AddAllStaffModal.propTypes = {
  handleAddAllStaffConfirmation: PropTypes.func.isRequired
};

export default AddAllStaffModal;
